import type { Legal, NavLinkColumn } from './types'

export const legal_fr: Legal[] = [
  {
    key: 'privacy_notice',
    name: 'Privacy Notice',
    href: '/privacy/france',
  },
  {
    key: 'status',
    name: 'Status',
    href: 'https://status.crypto.com',
  },
]

export const desktop_fr: NavLinkColumn[] = [
  [
    {
      tTitle: 'products.app',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'products.buyAndSell',
          href: '/fr/app',
        },
        {
          tTitle: 'products.earn',
          href: '/fr/earn',
        },
        {
          tTitle: 'products.pay',
          href: '/fr/pay',
        },
      ],
    },
    {
      tTitle: 'products.cards',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'products.metalCards',
          href: '/fr/cards',
        },
      ],
    },
  ],
  [
    {
      tTitle: 'products.commerce',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'products.payMerchant',
          href: '/fr/pay-merchant',
        },
      ],
    },
  ],
  [
    {
      tTitle: 'products.defi',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'products.wallet',
          href: '/fr/defi-wallet',
        },
        {
          tTitle: 'products.swap',
          href: 'https://crypto.com/defi/swap',
        },
        {
          tTitle: 'products.defiEarn',
          href: '/fr/defi-wallet#earn',
        },
        {
          tTitle: 'products.dashboard',
          href: 'https://crypto.com/defi/dashboard/gas-fees',
        },
      ],
    },
  ],
  [
    {
      tTitle: 'products.resources',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'products.prices',
          href: 'https://crypto.com/price',
        },
        {
          tTitle: 'products.siteWidgets',
          href: 'https://crypto.com/price/widget',
        },
        {
          tTitle: 'products.tax',
          href: 'https://tax.crypto.com',
        },
        {
          tTitle: 'company.support',
          href: 'https://help.crypto.com/en',
        },
        {
          tTitle: 'products.por',
          href: '/fr/proof-of-reserves',
        },
      ],
    },
  ],
  [
    {
      tTitle: 'navbar.learn',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'learn.trending',
          href: `/trending`,
        },
        {
          tTitle: 'learn.productNews',
          href: `/product-news`,
        },
        {
          tTitle: 'learn.events',
          href: `/events`,
        },
        {
          tTitle: 'learn.university',
          href: `/university`,
        },
        {
          tTitle: 'learn.research',
          href: `/research`,
        },
        {
          tTitle: 'learn.marketUpdates',
          href: `/market-updates`,
        },
        {
          tTitle: 'learn.nftStories',
          href: '/nft-stories',
        },
      ],
    },
  ],
  [
    {
      tTitle: 'navbar.company',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'company.about',
          href: '/fr/about',
        },
        {
          tTitle: 'company.careers',
          href: '/fr/careers',
        },
        {
          tTitle: 'company.news',
          href: `'https://crypto.com/company-news`,
        },
        {
          tTitle: 'company.security',
          href: '/fr/security',
        },
        {
          tTitle: 'company.contact',
          href: '/fr/about#page-contact',
        },
        {
          tTitle: 'company.capital',
          href: '/fr/capital',
        },
        {
          tTitle: 'company.climate',
          href: 'https://crypto.com/company-news/crypto-coms-climate-commitment-2',
        },
        {
          tTitle: 'company.affiliate',
          href: '/fr/affiliate',
        },
        {
          tTitle: 'company.partners',
          href: '/fr/partners',
        },
        {
          tTitle: 'navbar.nft',
          href: 'https://crypto.com/nft',
          tBadgeTitle: 'navbar.new',
        },
      ],
    },
  ],
]

export const mobile_fr = desktop_fr
  .flatMap((menu) => menu)
  .map(({ items, ...rest }) => ({
    items: items.filter(({ tTitle }) => tTitle !== 'navbar.nft'),
    ...rest,
  }))
  .concat([
    {
      tTitle: 'navbar.nft',
      tBadgeTitle: 'navbar.new',
      href: 'https://crypto.com/nft',
      items: [],
    },
  ])
